<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_toc_1"><span>Avec mes remerciements aux Cinq, qui m’ont poussée à croire en mon talent d’écrivain, ainsi qu’à ma mère et à mes grands-parents, grâce à qui je me suis sentie capable de tout.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?28c0e932